const state = {
  keopeToken: null
}

const getters = {
  keopeToken: state => state.keopeToken
}

const actions = {
  setKeopeToken ({ commit }, token) {
    commit('SET_KEOPE_TOKEN', token)
  }
}

const mutations = {
  SET_KEOPE_TOKEN (state, token) {
    state.keopeToken = token
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
